import { toJS } from 'mobx';

const mapByStatus = (documents, status) => {
    documents = toJS(documents);
    const result = [];

    for(const id in documents) {
        const current = documents[id];

        if (current.status === status) {
            result.push(current);
        }
    }

    return result;
}

export default {
    mapByStatus: mapByStatus
}



// WEBPACK FOOTER //
// ./src/helpers/Document.js